import { render, staticRenderFns } from "./BusinessLog.vue?vue&type=template&id=5049d622&scoped=true"
import script from "./BusinessLog.vue?vue&type=script&lang=js"
export * from "./BusinessLog.vue?vue&type=script&lang=js"
import style0 from "./BusinessLog.vue?vue&type=style&index=0&id=5049d622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049d622",
  null
  
)

export default component.exports